module.exports = __webpack_public_path__ + "static/media/CADS.3a752ad9.png";